module.exports = __webpack_public_path__ + "static/home7-e8293ba47211843c27694fe51ccf15bb.jpg";